// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__lp-vk","notes":"Notes_notes__1Higl","note":"Notes_note__6HOxg","markdown":"Notes_markdown__2agDu"};